module.exports = __webpack_public_path__ + "static/media/logo-nygh.34808570.svg";